<template>
    <div>
        <b-row>
            <b-col cols="12" md="6" lg="2">
                <app-form-select-input
                    placeholder="Tipo"
                    v-model="filters.type"
                    :options="annotationTypes"
                />
            </b-col>
            <b-col cols="12" md="6" lg="2">
                <app-form-select-input
                    placeholder="Autor"
                    :options="authors"
                    v-model="filters.author"
                />
            </b-col>
            <b-col cols="12" md="6" lg="2">
                <app-date-time-picker
                    id="from"
                    placeholder="Desde"
                    v-model="filters.from"
                    :with-time="false"
                />
            </b-col>
            <b-col cols="12" md="6" lg="2">
                <app-date-time-picker
                    id="to"
                    placeholder="Hasta"
                    v-model="filters.to"
                    :with-time="false"
                />
            </b-col>
            <b-col>
                <app-form-text-input
                    v-model="filters.term"
                    placeholder="Palabra"
                ></app-form-text-input>
            </b-col>
            <b-col cols="12" md="12" lg="2">
                <app-form-select-input
                    placeholder="¿Tiene archivos?"
                    :options="files"
                    v-model="filters.file"
                ></app-form-select-input>
            </b-col>
            <b-col cols="12" md="6" lg="2">
                <b-checkbox
                    v-model="filters.ofSupervision"
                    value="1"
                    unchecked-value=""
                    >Solo supervisores</b-checkbox
                >
            </b-col>
            <b-col cols="12" md="4" lg="1" offset-lg="7">
                <b-button
                    size="sm"
                    variant="primary"
                    @click="onFilter"
                    class="btn-block"
                    ><i class="fa fa-filter"></i
                ></b-button>
            </b-col>
            <b-col cols="12" md="4" lg="1">
                <b-button
                    size="sm"
                    variant="primary"
                    @click="onDownload"
                    class="btn-block"
                    ><i class="fa fa-download" aria-hidden="true"></i
                ></b-button>
            </b-col>
            <b-col cols="12" md="4" lg="1">
                <b-button
                    size="sm"
                    variant="secondary"
                    @click="cleanFilter"
                    class="btn-block"
                    ><i class="fa fa-times-circle"></i
                ></b-button>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        annotationTypes: {
            required: true,
        },
        authors: {
            required: true,
        },
    },

    data() {
        return {
            filters: {
                type: '',
                date: '',
                from: '',
                to: '',
                file: '',
                term: '',
                ofSupervision: '',
            },
            files: [
                {
                    id: 1,
                    name: 'Si',
                },
                {
                    id: 0,
                    name: 'No',
                },
            ],
        }
    },

    methods: {
        onFilter() {
            this.$emit('filter', this.filters)
        },
        cleanFilter() {
            Object.keys(this.filters).map(key => (this.filters[key] = ''))
            this.$emit('clean', this.filters)
        },
        onDownload() {
            this.$emit('download', this.filters)
        },
    },

    created() {
        this.$bus.$on('filters.clean', this.cleanFilter)
    },
}
</script>
